import { ProductEntry, TransportEntry } from "@/types/product/productStep.types";

/**
 * Ensure a product entry has a `transports` array. Footprints saved before
 * multi-transport support only have the single `transportType`/`transportDistance`
 * fields; migrate those into a one-element array so the forms and calculations
 * work uniformly. Entries that already have `transports` are returned untouched.
 */
export function normalizeProductTransports(entry: ProductEntry): ProductEntry {
  if (entry.transports && entry.transports.length > 0) {
    return entry;
  }
  if (entry.transportType || entry.transportDistance) {
    const leg: TransportEntry = {
      vehicleType: entry.transportType || "",
      distance: (entry.transportDistance as number) ?? (undefined as unknown as number),
    };
    return { ...entry, transports: [leg] };
  }
  return entry;
}
